import { ChildrenOnly } from '../../../../../../../common/types/ChildrenOnly';
import { Label, Overlay, Frame } from './FeaturedTag.styles';

export const FeaturedTag = ({ children }: ChildrenOnly) => (
  <Frame>
    {children}
    <Overlay>
      <Label>Featured</Label>
    </Overlay>
  </Frame>
);
